import { useEffect, useState } from 'react';
import { Alert, Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import InternalOrderFormSection from './InternalOrderFormSection';
import { getInternalOrderApiErrorMessage } from '../utils/internalOrdersUtils';
import { guardDialogClose } from '../../utils/actionLockUtils';
import { INTERNAL_DESTINATION_TEXTS } from '../constants/internalDestinationTexts';

const InternalOrderDialog = ({
  open,
  onClose,
  groupOptions, groupSearch, setGroupSearch, changeGroups,
  operationalDestinations = [],
  selectedOrder,
  onInputChange,
  onSelectChange,
  onSave,
  warehouses = [],
  warehousesLoading = false,
  projects = [],
  projectsLoading = false,
  searchEnabled = true,
  onAddMaterial,
  onUpdateMaterialQuantity,
  onRemoveMaterial,
  isSaving = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (open) {
      setErrorMessage('');
    }
  }, [open]);

  const commonProps = {
    operationalDestinations,
    groupOptions, groupSearch, setGroupSearch, changeGroups,
    selectedOrder,
    onInputChange: (event) => {
      onInputChange(event);
      if (errorMessage) setErrorMessage('');
    },
    onSelectChange: (event) => {
      onSelectChange(event);
      if (errorMessage) setErrorMessage('');
    },
    isMobile,
    warehouses,
    warehousesLoading,
    projects,
    projectsLoading,
    searchEnabled,
    onAddMaterial,
    onUpdateMaterialQuantity,
    onRemoveMaterial,
  };

  const handleSave = async () => {
    try {
      setErrorMessage('');
      const saved = await onSave();
      if (!saved) {
        setErrorMessage(INTERNAL_DESTINATION_TEXTS.incomplete);
      }
    } catch (error) {
      console.error('Error al guardar el pedido interno:', error);
      setErrorMessage(getInternalOrderApiErrorMessage(error, 'No se pudo crear el pedido interno'));
    }
  };

  return (
    <DialogContainer
      open={open}
      onClose={guardDialogClose(isSaving, onClose)}
      size={isMobile ? 'small' : 'large'}
      minHeight={isMobile ? '70vh' : '60vh'}
    >
      <DialogTitle>Nuevo pedido interno</DialogTitle>

      {errorMessage && (
        <Box sx={{ px: isMobile ? 2 : 3, pt: 2 }}>
          <Alert severity="error">{errorMessage}</Alert>
        </Box>
      )}

      <DialogBody>
        <Box sx={{ width: '100%' }}>
          <InternalOrderFormSection {...commonProps} />
        </Box>
      </DialogBody>

      <DialogActions
        handleClose={onClose}
        handleSave={handleSave}
        saveLabel="Crear"
        saveButtonProps={{ isLoading: isSaving }}
      />
    </DialogContainer>
  );
};

export default InternalOrderDialog;
